module.exports = __webpack_public_path__ + "static/media/beef4.0baf2498.jpg";